import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VesselScheduleRoutingModule } from './vessel-schedule-routing.module';
import { VesselScheduleComponent } from './vessel-schedule/vessel-schedule.component';
import { MaterialModule } from '../material-module';
import { FormsModule } from '@angular/forms';
import { VsTimelineComponent } from '../../../../shared/src/app/vs-timeline/vs-timeline.component';
import { Overlay, CloseScrollStrategy } from '@angular/cdk/overlay';
import { MAT_AUTOCOMPLETE_SCROLL_STRATEGY } from '@angular/material/autocomplete';
import { SharedModule } from '../../../../shared/src/app/shared/shared.module';


export function scrollFactory(overlay: Overlay): () => CloseScrollStrategy {
  return () => overlay.scrollStrategies.close();
}


@NgModule({
  declarations: [
    VesselScheduleComponent
  ],
  imports: [
    CommonModule,
    VesselScheduleRoutingModule,
    FormsModule,
    VsTimelineComponent,
    MaterialModule,
    SharedModule
  ],
  providers: [
    { provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY, useFactory: scrollFactory, deps: [Overlay] }

  ],
})
export class VesselScheduleModule { }
